import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { TableActionComponent } from './table-action/table-action.component';
import {NzCardModule} from 'ng-zorro-antd/card';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NzFormModule} from 'ng-zorro-antd/form';
import {FormsModule} from '@angular/forms';
import {NzCheckboxModule} from 'ng-zorro-antd/checkbox';
import {NzInputModule} from 'ng-zorro-antd/input';
import {VssUiDirectivesModule} from '../directives/vss-ui-directives.module';
import {VssUiControlsModule} from '../controls/vss-ui-controls.module';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzTableModule} from 'ng-zorro-antd/table';
import {NzResizableModule} from 'ng-zorro-antd/resizable';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {NzDropDownModule} from 'ng-zorro-antd/dropdown';
import {PipeModule} from '../pipe/pipe.module';
import {NzDividerModule} from 'ng-zorro-antd/divider';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzTagModule} from 'ng-zorro-antd/tag';
import {NzBadgeModule} from 'ng-zorro-antd/badge';
import {NzProgressModule} from 'ng-zorro-antd/progress';
import {NzInputNumberModule} from 'ng-zorro-antd/input-number';
import {NzEmptyModule} from 'ng-zorro-antd/empty';
import {NzPopconfirmModule} from 'ng-zorro-antd/popconfirm';
import {UpdateItemModalComponent} from './update-item-modal/update-item-function.component';
import {PermissionModule} from '../permission/permission.module';
import {NotificationModule} from '../notification/notification.module';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {VssAdminService} from '../../services/vss-admin.service';
import {VssUiConfig} from '../../vss-ui.model';
import {NzMessageService} from 'ng-zorro-antd/message';
import {vssProviders} from '../../vss.providers';
import { ExcelTableComponent } from './excel-table/excel-table.component';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { LinkListComponent } from './link-list/link-list.component'
import { TranslateModule } from '@ngx-translate/core';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import {NzImageModule} from "ng-zorro-antd/image";



@NgModule({
  declarations: [
    TableComponent,
    TableActionComponent,
    UpdateItemModalComponent,
    ExcelTableComponent,
    LinkListComponent
  ],
  exports: [
    TableComponent,
    TableActionComponent,
    UpdateItemModalComponent,
    ExcelTableComponent
  ],
    imports: [
        CommonModule,
        NzCardModule,
        DragDropModule,
        NzFormModule,
        FormsModule,
        NzCheckboxModule,
        NzInputModule,
        VssUiDirectivesModule,
        VssUiControlsModule,
        NzSelectModule,
        NzButtonModule,
        NzIconModule,
        NzTableModule,
        NzResizableModule,
        NzToolTipModule,
        NzDropDownModule,
        PipeModule,
        NzDividerModule,
        NzPopoverModule,
        NzTagModule,
        NzBadgeModule,
        NzProgressModule,
        NzInputNumberModule,
        NzEmptyModule,
        NzPopconfirmModule,
        PermissionModule,
        NotificationModule,
        NzSwitchModule,
        TranslateModule,
        NzDatePickerModule,
        NzImageModule,
    ],
  providers: [
    ...vssProviders
  ]
})
export class TableModule { }
